import { createFileRoute } from '@tanstack/react-router'
import ImportRetailOders from 'Administration/components/import/RetailerOrders/ImportRetailOders'

import AdministrationPage from '../../-administrationPage'
import { Guard } from '../../-guard'

export const Route = createFileRoute('/administration/imports/createretailerorders')({
    component: () => (
        <Guard claims={['opus_integration']}>
            <AdministrationPage>
                <ImportRetailOders />
            </AdministrationPage>
        </Guard>
    ),
})
